<main
  class="profile"
  id="main-content"
  tabindex="-1">
  <h1
    class="profile__title"
    id="profile-title">
    {{ 'Profile' | translate }}
  </h1>
  <div class="profile__name">
    {{ name$ | async }}
  </div>
  <div class="profile__select">
    <label
      for="select-language"
      class="profile__select__label">
      {{ 'Language:' | translate }}
    </label>
    <div class="profile__select__type">
      <div class="profile__select__type__wrapper">
        <select
          #languageSelect
          (change)="toggleLanguage(languageSelect.value); $event.preventDefault()"
          [ngModel]="language$ | async"
          class="profile__select__type__select"
          id="select-language">
          <option value="en">{{ 'English' | translate }}</option>
          <option value="es">{{ 'Spanish' | translate }}</option>
          <option value="ro">{{ 'Romanian' | translate }}</option>
        </select>
      </div>
    </div>
  </div>
  <div
    class="profile__tab-position"
    role="radiogroup"
    aria-labelledby="tab-position-label">
    <div
      id="tab-position-label"
      class="profile__tab-position__label">
      {{ 'Tab position:' | translate }}
    </div>
    <label for="top">
      <input
        #top
        (click)="toggleTabPosition('top')"
        [checked]="(tabPosition$ | async) === 'top'"
        id="top"
        name="tab"
        type="radio"
        value="top"
        [attr.aria-label]="'top' | translate" />
      <span
        [class.selected]="top.checked"
        class="profile__tab-position--top">
        <mat-icon>arrow_upward</mat-icon>
      </span>
    </label>
    <label for="left">
      <input
        #left
        (click)="toggleTabPosition('left')"
        [checked]="(tabPosition$ | async) === 'left'"
        id="left"
        name="tab"
        type="radio"
        value="left"
        [attr.aria-label]="'left' | translate" />
      <span
        [class.selected]="left.checked"
        class="profile__tab-position--left">
        <mat-icon>arrow_back</mat-icon>
      </span>
    </label>
  </div>
  @if (shouldShowPin$ | async) {
    <div
      class="profile__pin"
      [class.profile__pin--extended]="teacherPinExtended$ | async">
      <div class="profile__pin__label">
        {{ 'Teacher Tools PIN:' | translate }}
      </div>
      @if (teacherPinExtended$ | async) {
        <div class="profile__pin__extended-input-wrapper">
          <input
            #extendedPinInput
            class="profile__pin__extended-input"
            [class.error]="extendedPinTouched && !extendedPinValid"
            type="text"
            inputmode="numeric"
            [value]="currentPin"
            (input)="onExtendedPinInput($any($event.target).value)"
            (keydown)="onKeyDown($event)"
            [disabled]="pinDisabled"
            maxlength="maxExtendedPinLength"
            aria-label="{{ 'Teacher Tools PIN' | translate }}" />
          @if (extendedPinTouched && !extendedPinValid) {
            <div class="profile__pin__extended-input-error">
              {{ 'Must be 4-8 characters and only contain numbers.' | translate }}
            </div>
          }
        </div>
      } @else {
        <code-input
          #code
          [disabled]="pinDisabled"
          [code]="currentPin"
          (codeCompleted)="codeCompleted($event)"
          (codeChanged)="codeChanged()" />
      }
      <cl-help-button
        [icon]="Icon.info"
        expandTo="bottom">
        <div help>
          @if (teacherPinExtended$ | async) {
            {{
              'Your PIN must be 4–8 digits long and contain only numbers (0–9). No spaces or special characters are allowed.'
                | translate
            }}
          } @else {
            {{
              "The PIN is used to access the settings menu during a student's session. This allows you to skip or" +
                ' restart an activity, report a problem or exit a session but prevents students from doing so.'
                | translate
            }}
          }
        </div>
      </cl-help-button>
    </div>
    <div class="actions">
      <cl-btn
        (click)="cancelPin()"
        [buttonStyle]="
          !(teacherPinExtended$ | async)
            ? !pinChangedOrEditing
              ? 'disabled secondary'
              : 'secondary'
            : !pinChanged
              ? 'disabled secondary'
              : 'secondary'
        "
        [id]="'cancel-button'">
        {{ 'Cancel' | translate }}
      </cl-btn>
      <cl-btn
        (click)="savePin()"
        [buttonStyle]="
          !(teacherPinExtended$ | async)
            ? !currentPin || !pinChanged
              ? 'disabled'
              : ''
            : !extendedPinValid || !pinChanged
              ? 'disabled'
              : ''
        "
        [id]="'save-button'">
        {{ 'Save' | translate }}
      </cl-btn>
    </div>
  }
  <iframe
    class="profile__request__frame"
    id="requestTarget"
    name="requestTarget"
    src=""
    title="Request target"></iframe>
</main>
